// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1FK07","rootSmall":"AddTileButton_rootSmall__3n9KB"};